<template>
    <div class="row mb-5 align-items-center">
        <div class="col-12">
            <ValidationObserver ref="storeForm">

                <div class="row">
                    <div class="col-12">
                        <ValidationProvider rules="required" v-slot="{ valid, errors }">
                            <b-form-group>
                                <label>{{ $t('Type') }}</label>
                                <multi-selectbox v-model="form.model" :options="[{text:'Course Enrollment',value:'session'},{text:'Time-Off',value: 'time_off'}]" :multiple="false" :validate-error="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12">
                        <ValidationProvider name="academic_year" rules="required" v-slot="{ valid, errors }">
                            <b-form-group>
                                <label>{{ $t('academic_year') }}</label>
                                <academic-years-selectbox v-model="form.academic_year" :validate-error="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12" v-if="form.academic_year">
                        <ValidationProvider name="module_date_id" rules="required" v-slot="{ valid, errors }">
                            <b-form-group>
                                <label>{{ $t('module') }}</label>
                                <module-date-selectbox ref="moduleDate" v-model="form.module_date_id" :academic_year="form.academic_year" :validate-error="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12" v-if="['session'].includes(form.model) && form.module_date_id">
                        <ValidationProvider name="session_id" :rules="['session'].includes(form.model)?'required':''" v-slot="{ valid, errors }">
                            <b-form-group>
                                <label>{{ $t('course') }}</label>
                                <SessionsSelectbox v-model="form.session_id" :module-date-id="form.module_date_id" :validate-error="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12" v-if="['time_off'].includes(form.model) && form.module_date_id">
                            <ValidationProvider name="type" :rules="['time_off'].includes(form.model)?'required':''" v-slot="{ valid, errors }">
                                <b-form-group :label="$t('type')">
                                    <parameter-selectbox code="time_off_types" v-model="form.type" :validate-error="errors[0]"></parameter-selectbox>
                                </b-form-group>
                            </ValidationProvider>
                                <b-form-group :label="$t('start_date') + ' / ' + $t('end_date')">
                                    <ValidationProvider name="date" :rules="['time_off'].includes(form.model)?'required':''" v-slot="{ valid, errors }">
                                        <v-date-picker
                                            v-model="form.date"
                                            is-range
                                            :locale="'en'"
                                            :model-config="{ type: 'string', mask: 'MM/DD/YYYY' }"
                                        >
                                            <template v-slot="{ inputValue, inputEvents }">
                                                <div class="border rounded-sm p-2 p-md-3 d-flex align-items-center"
                                                     :class="errors[0] ? 'box-border-color' : ''">
                                                    <div class="flex-grow-1">
                                                        <b-form-group class="m-0 mr-2">
                                                            <input
                                                                :value="inputValue.start"
                                                                v-on="inputEvents.start"
                                                                :placeholder="$t('start_date')"
                                                                class="form-control"
                                                            />
                                                        </b-form-group>
                                                    </div>
                                                    <div class="flex-grow-1">
                                                        <b-form-group class="m-0 ml-2">
                                                            <input
                                                                :value="inputValue.end"
                                                                v-on="inputEvents.end"
                                                                :placeholder="$t('end_date')"
                                                                class="form-control"
                                                            />
                                                        </b-form-group>
                                                    </div>
                                                </div>
                                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                                            </template>
                                        </v-date-picker>
                                    </ValidationProvider>
                                </b-form-group>
                            <b-form-group :label="$t('explanation')">
                                <b-input-group class="mb-1">
                                    <b-form-textarea
                                        v-model="form.explanation"
                                        rows="3"
                                        max-rows="6"
                                    ></b-form-textarea>
                                </b-input-group>
                            </b-form-group>
                        </div>
                    </div>
            </ValidationObserver>
        </div>
        <div class="col-12 mt-3 d-flex">
            <b-button @click="save" type="button" variant="primary" class="btn-lg mr-2">
                {{ $t('save') | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>
<script>
import StudentSessionService from "@/services/StudentSessionService";
import showErrors from "@/helpers/showErrors";
import SessionsSelectbox from "@/components/interactive-fields/SessionsSelectbox.vue";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import ModuleDateSelectbox from "@/components/interactive-fields/ModuleDateSelectbox.vue";
import StudentTimeOfServices from "@/services/StudentTimeOfServices";
import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox.vue";
export default {
    props:{
        studentProgram:{
            type: Object,
        }
    },
    components: {AcademicYearsSelectbox, ModuleDateSelectbox, MultiSelectbox, SessionsSelectbox},
    data(){
        return {
            form : {
                type: null,
                module_date_id: null
            }
        }
    },

    methods: {
        async save(){
            const isValid =await this.$refs.storeForm.validate()
            if (!isValid) return
            if (['session'].includes(this.form.model)){
                this.form.student_program_id=this.studentProgram.id
                StudentSessionService.store(this.form)
                    .then(response => {
                        this.$toast.success(this.$t("api." + response.data.message));
                        this.$emit('successCreate',true)
                    }).catch(err=>{
                    showErrors(err,this.$refs.storeForm)
                })
            }
            if (['time_off'].includes(this.form.model)){
                this.form.start_date =this.form.date.start
                this.form.end_date =this.form.date.end
                this.form.student_program_id=this.studentProgram.id
                StudentTimeOfServices.store(this.form)
                    .then(response => {
                        this.$toast.success(this.$t("api." + response.data.message));
                        this.$emit('successCreate',true)
                    }).catch(err=>{
                    showErrors(err,this.$refs.storeForm)
                })
            }
        }
    },
  watch: {
    'form.module_date_id': function (newValue) {
      if(!newValue){
        return;
      }
      let moduleDate=this.$refs.moduleDate.getItem(newValue);
      this.form.date = {start: moduleDate.start_date, end : moduleDate.end_date};
    }
  }
}
</script>
